<template>
  <div class="order-container">
    <el-row>
      <el-col>
        <div class="header-block" ref="boxWidth">
          <span class="header-title">我的订单</span>
        </div>
      </el-col>
    </el-row>
    <div class="function-block">
      <el-input placeholder="请输入商品名称" v-model="query.appNames"></el-input>
      <!-- <el-select v-model="orderState" placeholder="请选择订单状态">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select> -->
      <div class="function-btn">
        <el-button class="btn bg-search" @click="search">搜索</el-button>
        <el-button class="btn" @click="reset">重置</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :cell-style="onTableCellStyle"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :max-height="tableHeight"
      :header-cell-style="{ background: '#FAFAFB' }"
    >
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column prop="enterpriseName" label="企业名称"></el-table-column>
      <el-table-column prop="orderNumber" label="订单编号">
        <template #default="scope">
          <router-link
            style="text-decoration: underline"
            :to="{
              path: 'details',
              query: { orderNumber: scope.row.orderNumber, enterpriseName: scope.row.enterpriseName }
            }"
            >{{ scope.row.orderNumber }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="appNames" label="商品">
        <template #default="scope">
          <router-link
            style="text-decoration: underline"
            :to="{
              path: 'details',
              query: { orderNumber: scope.row.orderNumber, enterpriseName: scope.row.enterpriseName }
            }"
            >{{ scope.row.appNames }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="totalAmount" label="价格">
        <template #default="scope">¥{{ numberPutCommaShow(scope.row.totalAmount / 100) }}</template>
      </el-table-column>
      <!-- scope.row代表的是后台返回的表格里这一行的数据
        而scope.row.order_state代表的是这一行数据里 order_state 的这个字段-->
      <!-- <el-table-column prop="orderState" label="订单状态">
        <template #default =  "scope">
          <el-tag type="danger" v-if="scope.row.orderState === 1">{{ constants.orderState[scope.row.orderState] }}
          </el-tag>
          <el-tag type="warning" v-if="scope.row.orderState === 2">待审核</el-tag>
          <el-tag type="danger" v-if="scope.row.orderState === 3">审核未通过</el-tag>
          <el-tag type="warning" v-if="scope.row.orderState === 4">待推送</el-tag>
          <el-tag type="danger" v-if="scope.row.orderState === 5">待支付</el-tag>
          <el-tag type="warning" v-if="scope.row.orderState === 6">审核中</el-tag>
          <el-tag type="success" v-if="scope.row.orderState === 7">
            {{
                constants.orderState[scope.row.orderState]
            }}
          </el-tag>
          <el-tag type="info" v-if="scope.row.orderState === 8">已取消</el-tag>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="payState" label="支付状态">
        <template #default =  "scope">
          <el-tag
            :type="
              scope.row.payState == 1
                ? 'success'
                : scope.row.payState == 0
                ? 'danger'
                : ''
            "
            disable-transitions
          >
            {{ constants.payState[scope.row.payState] }}
          </el-tag>
        </template>
      </el-table-column>-->
      <!-- <el-table-column label="操作" width="60">
        <template #default =  "scope">
          <el-button @click="onViewContract(scope.row)" type="text">查看合同</el-button>
        </template>
      </el-table-column>-->
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="text" v-if="scope.row.payState === 0 && scope.row.orderState === 5" @click="onPay(scope.row.orderNumber)"
            >去支付</el-button
          >
          <!-- <el-button @click="onViewContract(scope.row)" type="text" v-else-if="scope.row.orderState===7">查看合同</el-button> -->

          <!-- <el-button type="text" v-else-if="
          (scope.row.auditPayStatus === 1 &&
            scope.row.invoiceApplyStatus === 0) ||
          (scope.row.orderState === 7 && scope.row.invoiceApplyStatus === 0)"
            @click="onApplyInvoice(scope.row.orderNumber)">申请发票</el-button> -->
          <!-- <el-button type="text" v-else-if="
          scope.row.invoiceStatus === 0 &&
          scope.row.invoiceApplyStatus === 1" @click="onCheckInvoice(scope.row.orderNumber)">查看发票</el-button>
          <el-button type="text"
            v-else-if="
            scope.row.auditPayStatus === 1 && scope.row.invoiceStatus === 1 || scope.row.invoiceStatus === 1 && scope.row.payType == 1"
            @click="onCheckInvoice(scope.row.orderNumber)">查看发票</el-button> -->
          <el-button type="text" v-if="scope.row.invoiceStatus == 1" @click="onCheckInvoice(scope.row.orderNumber)">查看发票 </el-button>
          <el-button type="text" v-if="scope.row.orderState === 7 || scope.row.orderState === 6" @click="onCallPhoneDialog(scope.row.orderNumber)"
            >专属客服</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="footer-page-block" :style="'width:' + footerWidth + 'px'">
      <el-pagination
        @size-change="queryList"
        @current-change="queryList"
        :current-page.sync="pagination.current"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size.sync="pagination.pageSize"
        layout="prev,pager,next,sizes,jumper"
        prev-text="上一页"
        next-text="下一页"
        :total="pagination.total"
      ></el-pagination>
    </div>
    <!-- 支付 -->
    <paydlg v-model:visible="paymentDialogVisible" :order-number="orderNumber" @pay-success="onPaySuccess"></paydlg>
    <!-- 发票 -->
    <invoice
      :dialog="dialog"
      :checkDialog="checkDialog"
      :companyMainUserAccountId="companyMainUserAccountId"
      :callPhoneDialogVisible="callPhoneDialogVisible"
      :orderNumber="orderNumber"
      @update:checkDialog="checkDialog = faslse"
      @update:callPhoneDialogVisible="callPhoneDialogVisible = faslse"
    ></invoice>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ordersList } from "@api/company.js";
import Paydlg from "./Paydlg";
import Invoice from "./Invoice";
export default {
  // provide() {
  //   return {
  //     reload: this.reload
  //   };
  // },
  components: { Paydlg, Invoice },
  computed: {
    ...mapState({
      constants: (state) => state.constants,
      companyMainUserAccountId: (state) => state.user.companyMainUserAccountId,
      tenantId: (state) => state.user.tenantId,
      userAccountId: (state) => state.user.userAccountId
    })
  },
  data() {
    return {
      callPhoneDialogVisible: false,
      dialog: false,
      paymentDialogVisible: false,
      // 查看申请记录
      checkDialog: false,
      query: {
        /* companyId: "1234344454", */
        companyMainUserAccountId: "",
        appNames: "",
        orderState: "",
        payState: "",
        sendStatus: 1,
        tenantId: ""
      },
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0
      },
      options: [
        {
          value: 1,
          label: "待支付"
        },
        {
          value: 2,
          label: "审核中"
        },
        // {
        //   value: 3,
        //   label: "已支付",
        // },
        {
          value: 4,
          label: "已完成"
        },
        {
          value: 5,
          label: "已取消"
        }
      ],
      tableData: [],
      multipleSelection: [],
      orderNumber: "",
      orderState: "",

      footerWidth: 0,
      tableHeight: 0,
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight
    };
  },
  watch: {
    screenWidth: {
      handler() {
        this.footerWidth = this.$refs.boxWidth.offsetWidth;
      }
    },

    screenHeight: {
      immediate: true,
      handler() {
        this.tableHeight = document.documentElement.clientHeight - 300;
      }
    },
    tenantId: {
      // immediate: true,
      handler(n) {
        if (n) {
          this.queryList();
        }
      }
    }
  },
  mounted() {
    this.$store.commit("user/setusuallyToken", {
      token: localStorage.getItem("token"),
      companyId: localStorage.getItem("currentCompany"),
      tag: "myOrder"
    });
    this.$store.commit("user/setOrderToken", this.$store.state.auth.userData.userAccountId);
    sessionStorage.setItem("userAccountId", this.$store.state.auth.userData.userAccountId);

    this.query.companyMainUserAccountId = this.$store.state.auth.userData?.userAccountId ?? "";
    this.$store.commit("user/setCompanyMainUserAccountId", this.$store.state.auth.userData?.userAccountId ?? "");

    this.$store.commit("user/setAuditPerson", this.$store.state.auth.userData?.userName ?? "");
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        window.screenHeight = document.body.clientHeight;
        that.screenHeight = window.screenHeight;
      })();
    };
    this.$nextTick(() => {
      this.footerWidth = this.$refs.boxWidth.offsetWidth;
      this.tableHeight = document.documentElement.clientHeight - 300;
    });
    // if (this.tenantId || sessionStorage.getItem("tenantId")) {
    //   this.queryList();
    // }
  },
  methods: {
    // reload() {
    //   // this.isRouterAlive = false;
    //   this.$nextTick(function () {
    //     // this.isRouterAlive = true;
    //   });
    // },
    numberPutCommaShow(value) {
      let installVal = value;
      if (value != "") {
        value = Number(value).toFixed(2);
        let intPart = Math.trunc(value); // 获取整数部分
        let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
        let floatPart = ".00"; // 预定义小数部分
        let value2Array = value.split(".");
        // =2表示数据有小数位
        if (value2Array.length === 2) {
          floatPart = value2Array[1].toString(); // 拿到小数部分
          if (floatPart.length === 1) {
            // 补0,实际上用不着
            return intPartFormat + "." + floatPart + "0";
          } else {
            if (installVal < 0 && intPartFormat == 0) {
              return "-" + intPartFormat + "." + floatPart;
            } else {
              return intPartFormat + "." + floatPart;
            }
          }
        } else {
          return intPartFormat + floatPart;
        }
      } else if (value == 0 && String(value)) {
        return "0.00";
      }
    },
    onTableCellStyle({ columnIndex }) {
      if (columnIndex === 1 || columnIndex === 2) {
        return "color:#2F80ED;";
      } else if (columnIndex === 4) {
        return "color:#333333;font-size:12px;";
      }
    },
    queryList() {
      this.query.companyMainUserAccountId = this.userAccountId || sessionStorage.getItem("userAccountId");
      this.query.tenantId = this.tenantId || sessionStorage.getItem("tenantId");
      ordersList({ pagination: this.pagination, query: this.query })
        .then((res) => {
          if (res.data == null) {
            this.tableData = [];
          } else {
            this.pagination.current = res.data.pagination.current;
            this.pagination.pageSize = res.data.pagination.pageSize;
            this.pagination.total = res.data.pagination.total;
            this.tableData = res.data.sources;
          }
        })
        .catch((res) => {
          console.log("catch ======>", res);
        });
    },
    search() {
      this.pagination.current = 1;
      if (this.orderState === 1) {
        this.query.payState = "";
        this.query.orderState = 5;
      } else if (this.orderState === 2) {
        this.query.orderState = 6;
        this.query.payState = "";
      }
      // else if(this.orderState===3){
      // this.query.payState=1
      //  this.query.orderState=""
      // this.query.orderState=""
      // }
      else if (this.orderState === 4) {
        this.query.orderState = 7;
        this.query.payState = "";
      } else if (this.orderState === 5) {
        this.query.orderState = 8;
        this.query.payState = "";
      }
      this.pagination.total = 0;
      this.queryList();
    },
    reset() {
      this.query = {
        appNames: "",
        orderState: "",
        payState: "",
        companyMainUserAccountId: this.userAccountId,
        sendStatus: 1,
        tenantId: this.tenantId
      };
      this.orderState = "";
      this.pagination.current = 1;
      this.queryList();
    },
    onPay(data) {
      this.paymentDialogVisible = true;
      this.orderNumber = data;
    },
    onPaySuccess() {
      this.queryList();
    },
    onApplyInvoice(data) {
      this.dialog = true;
      this.orderNumber = data;
    },
    onCheckInvoice(data) {
      this.checkDialog = true;
      this.orderNumber = data;
    },
    // onViewContract() {
    //   this.$router.push("index/contract");
    // },
    onCallPhoneDialog(data) {
      this.callPhoneDialogVisible = true;
      this.orderNumber = data;
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("user/setTenantId", "");
    next();
  },
};
</script>
<style lang="less" scoped>
.order-container {
  background-color: #fff;
  // padding: 24px 28px;
  min-width: 1148px;

  // height: 100vh;
  .header-block {
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 68px;
    border-bottom: 2px solid #d65900;

    .header-title {
      font-size: 24px;
      font-weight: bold;
      line-height: 1.2;
      color: #171721;
    }
  }

  .function-block {
    margin-top: 21px;
    display: flex;
    justify-content: flex-start;

    .function-btn {
      margin-left: 20px;

      .btn {
        font-size: 10px;
        border-radius: 36.19px;
        color: #333;
      }

      .bg-search {
        color: #fff;
        background: #ff6a00;
      }
    }

    .el-input {
      width: 180px;
      margin-right: 20px;
    }

    :v-deep(.el-input__inner) {
      width: 180px;
      height: 36px;
      border-radius: 3px;
      border: 1px solid #ff6a00;
      color: #92929d;
      font-size: 12px;
      background: #fff;
    }

    :v-deep(.el-icon-arrow-up::before) {
      color: #ff6a00;
    }
  }

  .el-table {
    color: #8083a3;
    margin-top: 20px;
  }

  .footer-page-block {
    z-index: 999;
    background: #fff;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
    padding-bottom: 20px;

    .el-pagination {
      :v-deep(.el-pager li.active) { 
        background-color: #ff6a00 !important;
        border-radius: 28%;
        color: #ffffff;
        height: 30px;
      }

      :v-deep(.el-pagination__jump) {
        color: #2f80ed;
      }
    }
  }
}
</style>
